import OrderSteps from './OrderSteps.view';

export default OrderSteps;
